export default "__VITE_ASSET__DS69GkRn__"